module.exports = __webpack_public_path__ + "static/img/guoyao-logo.31b548ac.png";